module.exports = __webpack_public_path__ + "img/onda_para_voce.a01b37e7.png";